import script from "./WConsolidatedReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./WConsolidatedReport.vue?vue&type=script&setup=true&lang=ts"

import "./WConsolidatedReport.vue?vue&type=style&index=0&id=21479bcb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21479bcb"]])

export default __exports__